import { FrequencyPeriodEnum } from './FrequencyPeriodEnum';
import { VenueId } from '../../venues/venues.types';

export enum DigestNotificationTypeEnum {
    NewGeneralAnnouncement = 0,
    WalletUpdated = 1,
    NewDirectMessage = 2,
    NewKnowledgeLibraryItem = 3,
    NewPocPost = 4,
    ReportPostedForPurchase = 5,
    NewPmgClubhousePost = 6,
    GroupCalendarEventUpdates = 7,
    GroupEventStatusChange = 8,
    GroupServicesOrderStatusChange = 9,
    ReferredPartyRegistered = 10,
    RewardCreditSweepAdvancedNotice = 11,
    // VV Connect
    DeadlineReminder24Hours = 12,
    DeadlineReminderCustomDays = 13,
    NewEngagementDocumentsPosted = 14,
    UpdatedPostDataNdaTermsNegotiation = 15,
    UpdatedMeetingSchedulingPost = 16,
    VdrUpdate = 17,
    NewSellerStepBegins = 18,
    NewMessageInBuyerChat = 19,
    NewMessageInBrokerChat = 20,
    UpdateToBuyersTable = 21,
    PracticeDataAndDocsNewProject = 22,
    NewMessageInSellerChat = 23,
    NewOpportunitiesPosted = 24,
    NewBuyerStepBegins = 25,
    LegalDocumentUpdated = 26,
    MeetingStartReminder = 27,
    MeetingStarted = 28,
    DeadlineReminder6Hours = 29,
    MonthlyEngagementFeeInvoicePosted = 30,
    TeamMemberInvited = 31,
    TransactionDocumentsDraftsPosted = 33,
}

export const DigestNotificationLabels = [
    {
        id: DigestNotificationTypeEnum.NewGeneralAnnouncement,
        name: 'General Announcement',
    },
    {
        id: DigestNotificationTypeEnum.WalletUpdated,
        name: 'Wallet receipt/payment update',
    },
    {
        id: DigestNotificationTypeEnum.NewDirectMessage,
        name: 'New direct message receipt',
    },
    {
        id: DigestNotificationTypeEnum.NewKnowledgeLibraryItem,
        name: 'New Knowledge Library item',
    },
    {
        id: DigestNotificationTypeEnum.NewPocPost,
        name: 'New IPOC post',
    },
    {
        id: DigestNotificationTypeEnum.ReportPostedForPurchase,
        name: 'Report posted for purchase',
    },
    {
        id: DigestNotificationTypeEnum.NewPmgClubhousePost,
        name: 'New ClubBoard post',
    },
    {
        id: DigestNotificationTypeEnum.GroupCalendarEventUpdates,
        name: 'Group Calendar event / reminder / deadline',
    },
    {
        id: DigestNotificationTypeEnum.GroupEventStatusChange,
        name: 'Group Event Status change',
    },
    {
        id: DigestNotificationTypeEnum.GroupServicesOrderStatusChange,
        name: 'Group Services Order status change',
    },
    {
        id: DigestNotificationTypeEnum.ReferredPartyRegistered,
        name: 'New Referree Registration',
    },
    {
        id: DigestNotificationTypeEnum.RewardCreditSweepAdvancedNotice,
        name: 'Reward Credit sweep advanced notice',
    },
    {
        id: DigestNotificationTypeEnum.DeadlineReminder24Hours,
        name: 'Final Deadline Reminder (24 hours)',
    },
    {
        id: DigestNotificationTypeEnum.DeadlineReminderCustomDays,
        name: 'Deadline Reminder (custom)',
    },
    {
        id: DigestNotificationTypeEnum.NewEngagementDocumentsPosted,
        name: 'New Engagement Documents Posted',
    },
    {
        id: DigestNotificationTypeEnum.UpdatedPostDataNdaTermsNegotiation,
        name: 'Updated Post in Data NDA Terms Negotiation',
    },
    {
        id: DigestNotificationTypeEnum.UpdatedMeetingSchedulingPost,
        name: 'Updated Meeting Scheduling Post',
    },
    {
        id: DigestNotificationTypeEnum.VdrUpdate,
        name: 'VDR Update',
    },
    {
        id: DigestNotificationTypeEnum.NewSellerStepBegins,
        name: 'New Seller Step Begins',
    },
    {
        id: DigestNotificationTypeEnum.NewMessageInBuyerChat,
        name: 'New Message in Buyer Chat',
    },
    {
        id: DigestNotificationTypeEnum.NewMessageInBrokerChat,
        name: 'New Message in Advisor Chat',
    },
    {
        id: DigestNotificationTypeEnum.UpdateToBuyersTable,
        name: "Update to Buyer's Table",
    },
    {
        id: DigestNotificationTypeEnum.PracticeDataAndDocsNewProject,
        name: 'New Practice Data & Docs Request',
    },
    {
        id: DigestNotificationTypeEnum.NewMessageInSellerChat,
        name: 'New Message in Seller Chat',
    },
    {
        id: DigestNotificationTypeEnum.NewOpportunitiesPosted,
        name: 'New Opportunity Posted',
    },
    {
        id: DigestNotificationTypeEnum.NewBuyerStepBegins,
        name: 'New Buyer Step Begins',
    },
    {
        id: DigestNotificationTypeEnum.LegalDocumentUpdated,
        name: 'Update to the Terms of Service',
    },
    {
        id: DigestNotificationTypeEnum.MeetingStartReminder,
        name: 'Meeting Start Reminder',
    },
    {
        id: DigestNotificationTypeEnum.MeetingStarted,
        name: 'Meeting Has Started',
    },
    {
        id: DigestNotificationTypeEnum.MonthlyEngagementFeeInvoicePosted,
        name: 'Monthly Engagement Fee Invoice',
    },
    {
        id: DigestNotificationTypeEnum.TeamMemberInvited,
        name: 'New team member invited',
    },
    {
        id: DigestNotificationTypeEnum.TransactionDocumentsDraftsPosted,
        name: 'Initial Transaction Document Drafts Posted',
    },
];

export const DigestNotificationDefaultEmailFrequency = [
    {
        id: DigestNotificationTypeEnum.NewGeneralAnnouncement,
        frequency: FrequencyPeriodEnum.Weekly,
    },
    {
        id: DigestNotificationTypeEnum.WalletUpdated,
        frequency: FrequencyPeriodEnum.Daily,
    },
    {
        id: DigestNotificationTypeEnum.NewDirectMessage,
        frequency: FrequencyPeriodEnum.Daily,
    },
    {
        id: DigestNotificationTypeEnum.NewKnowledgeLibraryItem,
        frequency: FrequencyPeriodEnum.Daily,
    },
    {
        id: DigestNotificationTypeEnum.NewPocPost,
        frequency: FrequencyPeriodEnum.Daily,
    },
    {
        id: DigestNotificationTypeEnum.ReportPostedForPurchase,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.NewPmgClubhousePost,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.GroupCalendarEventUpdates,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.GroupEventStatusChange,
        frequency: FrequencyPeriodEnum.Daily,
    },
    {
        id: DigestNotificationTypeEnum.GroupServicesOrderStatusChange,
        frequency: FrequencyPeriodEnum.Daily,
    },
    {
        id: DigestNotificationTypeEnum.ReferredPartyRegistered,
        frequency: FrequencyPeriodEnum.Daily,
    },
    {
        id: DigestNotificationTypeEnum.RewardCreditSweepAdvancedNotice,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.DeadlineReminder24Hours,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.DeadlineReminderCustomDays,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.NewEngagementDocumentsPosted,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.UpdatedPostDataNdaTermsNegotiation,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.UpdatedMeetingSchedulingPost,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.VdrUpdate,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.NewSellerStepBegins,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.NewMessageInBuyerChat,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.NewMessageInBrokerChat,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.UpdateToBuyersTable,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.PracticeDataAndDocsNewProject,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.NewMessageInSellerChat,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.NewOpportunitiesPosted,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.NewBuyerStepBegins,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.LegalDocumentUpdated,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.MeetingStartReminder,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.MeetingStarted,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.MonthlyEngagementFeeInvoicePosted,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.TeamMemberInvited,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
    {
        id: DigestNotificationTypeEnum.TransactionDocumentsDraftsPosted,
        frequency: FrequencyPeriodEnum.PerEvent,
    },
];

export enum DigestNotificationCategory {
    CommunicationsAndPosts = 1,
    PmgUpdates = 2,
    WalletAndPayments = 3,
    VvConnect = 4,
    ReferralPartnerActivities = 5,
}

export enum NotificationRolesEnum {
    CurrentPracticeOwner,
    FormerPracticeOwner,
    PocMember,
    PmgMember,
    ReferralPartner,
    CharityAdmin,
    AspiringPracticeOwner,
    CorporatePracticeOwner,
    Broker,
    Buyer,
    BuyerInternalTeamMember,
    BuyerExternalTeamMember,
}

export const NotificationsCategories: NotificationCategoryDescriptor[] = [
    {
        category: DigestNotificationCategory.CommunicationsAndPosts,
        label: 'General',
        venueIds: [VenueId.Grow, VenueId.Ally, VenueId.Connect, VenueId.Share],
        notifications: [
            {
                type: DigestNotificationTypeEnum.NewGeneralAnnouncement,
                roles: [
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.FormerPracticeOwner,
                    NotificationRolesEnum.ReferralPartner,
                ],
            },
            {
                type: DigestNotificationTypeEnum.NewDirectMessage,
                roles: [
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.FormerPracticeOwner,
                    NotificationRolesEnum.ReferralPartner,
                    NotificationRolesEnum.CharityAdmin,
                ],
            },
            {
                type: DigestNotificationTypeEnum.LegalDocumentUpdated,
                roles: [
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.FormerPracticeOwner,
                    NotificationRolesEnum.ReferralPartner,
                    NotificationRolesEnum.CharityAdmin,
                    NotificationRolesEnum.Broker,
                    NotificationRolesEnum.Buyer,
                    NotificationRolesEnum.BuyerInternalTeamMember,
                    NotificationRolesEnum.BuyerExternalTeamMember,
                ],
            },
            {
                type: DigestNotificationTypeEnum.TeamMemberInvited,
                roles: [
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.CharityAdmin,
                    NotificationRolesEnum.Buyer,
                ],
            },
        ],
    },
    {
        category: DigestNotificationCategory.WalletAndPayments,
        label: 'Wallet and Payments',
        venueIds: [VenueId.Grow, VenueId.Ally, VenueId.Connect, VenueId.Share],
        notifications: [
            {
                type: DigestNotificationTypeEnum.WalletUpdated,
                roles: [
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.FormerPracticeOwner,
                    NotificationRolesEnum.ReferralPartner,
                    NotificationRolesEnum.CharityAdmin,
                ],
            },
            {
                type: DigestNotificationTypeEnum.ReportPostedForPurchase,
                roles: [NotificationRolesEnum.CurrentPracticeOwner],
            },
            {
                type: DigestNotificationTypeEnum.RewardCreditSweepAdvancedNotice,
                roles: [
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.FormerPracticeOwner,
                    NotificationRolesEnum.PmgMember,
                    NotificationRolesEnum.ReferralPartner,
                    NotificationRolesEnum.CharityAdmin,
                ],
            },
        ],
    },
    {
        category: DigestNotificationCategory.CommunicationsAndPosts,
        label: 'New Content Post',
        venueIds: [VenueId.Grow],
        notifications: [
            {
                type: DigestNotificationTypeEnum.NewKnowledgeLibraryItem,
                roles: [
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.FormerPracticeOwner,
                ],
            },
            {
                type: DigestNotificationTypeEnum.NewPocPost,
                roles: [
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.FormerPracticeOwner,
                    NotificationRolesEnum.CorporatePracticeOwner,
                    NotificationRolesEnum.PocMember,
                ],
            },
        ],
    },
    {
        category: DigestNotificationCategory.PmgUpdates,
        label: 'PMG Updates',
        venueIds: [VenueId.Grow],
        notifications: [
            {
                type: DigestNotificationTypeEnum.NewPmgClubhousePost,
                roles: [
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.PmgMember,
                ],
            },
            {
                type: DigestNotificationTypeEnum.GroupCalendarEventUpdates,
                roles: [
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.PmgMember,
                ],
            },
            {
                type: DigestNotificationTypeEnum.GroupEventStatusChange,
                roles: [
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.PmgMember,
                ],
            },
            {
                type: DigestNotificationTypeEnum.GroupServicesOrderStatusChange,
                roles: [
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.PmgMember,
                ],
            },
        ],
    },
    {
        category: DigestNotificationCategory.ReferralPartnerActivities,
        label: 'Referral Partner Activities',
        venueIds: [VenueId.Share],
        notifications: [
            {
                type: DigestNotificationTypeEnum.ReferredPartyRegistered,
                roles: [
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.FormerPracticeOwner,
                    NotificationRolesEnum.ReferralPartner,
                    NotificationRolesEnum.CharityAdmin,
                ],
            },
        ],
    },
    {
        category: DigestNotificationCategory.VvConnect,
        label: 'VV Connect',
        venueIds: [VenueId.Connect],
        notifications: [
            {
                type: DigestNotificationTypeEnum.DeadlineReminder24Hours,
                roles: [
                    NotificationRolesEnum.Broker,
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.Buyer,
                    NotificationRolesEnum.BuyerInternalTeamMember,
                ],
                order: {
                    [NotificationRolesEnum.Broker]: 2,
                    [NotificationRolesEnum.CurrentPracticeOwner]: 2,
                    [NotificationRolesEnum.Buyer]: 2,
                },
            },
            {
                type: DigestNotificationTypeEnum.DeadlineReminderCustomDays,
                roles: [
                    NotificationRolesEnum.Broker,
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.Buyer,
                    NotificationRolesEnum.BuyerInternalTeamMember,
                ],
                order: {
                    [NotificationRolesEnum.Broker]: 1,
                    [NotificationRolesEnum.CurrentPracticeOwner]: 1,
                    [NotificationRolesEnum.Buyer]: 1,
                },
            },
            {
                type: DigestNotificationTypeEnum.NewEngagementDocumentsPosted,
                roles: [
                    NotificationRolesEnum.Broker,
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.Buyer,
                    NotificationRolesEnum.BuyerInternalTeamMember,
                    NotificationRolesEnum.BuyerExternalTeamMember,
                ],
                order: {
                    [NotificationRolesEnum.Broker]: 6,
                    [NotificationRolesEnum.CurrentPracticeOwner]: 6,
                    [NotificationRolesEnum.Buyer]: 5,
                },
            },
            {
                type: DigestNotificationTypeEnum.UpdatedPostDataNdaTermsNegotiation,
                roles: [
                    NotificationRolesEnum.Broker,
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.Buyer,
                    NotificationRolesEnum.BuyerInternalTeamMember,
                ],
                order: {
                    [NotificationRolesEnum.Broker]: 8,
                    [NotificationRolesEnum.CurrentPracticeOwner]: 8,
                    [NotificationRolesEnum.Buyer]: 6,
                },
            },
            {
                type: DigestNotificationTypeEnum.UpdatedMeetingSchedulingPost,
                roles: [
                    NotificationRolesEnum.Broker,
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.Buyer,
                    NotificationRolesEnum.BuyerInternalTeamMember,
                ],
                order: {
                    [NotificationRolesEnum.Broker]: 10,
                    [NotificationRolesEnum.CurrentPracticeOwner]: 10,
                    [NotificationRolesEnum.Buyer]: 8,
                },
            },
            {
                type: DigestNotificationTypeEnum.MeetingStartReminder,
                roles: [
                    NotificationRolesEnum.Broker,
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.Buyer,
                    NotificationRolesEnum.BuyerInternalTeamMember,
                ],
                order: {
                    [NotificationRolesEnum.Broker]: 11,
                    [NotificationRolesEnum.CurrentPracticeOwner]: 11,
                    [NotificationRolesEnum.Buyer]: 9,
                },
            },
            {
                type: DigestNotificationTypeEnum.MeetingStarted,
                roles: [
                    NotificationRolesEnum.Broker,
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.Buyer,
                    NotificationRolesEnum.BuyerInternalTeamMember,
                ],
                order: {
                    [NotificationRolesEnum.Broker]: 12,
                    [NotificationRolesEnum.CurrentPracticeOwner]: 12,
                    [NotificationRolesEnum.Buyer]: 10,
                },
            },
            {
                type: DigestNotificationTypeEnum.VdrUpdate,
                roles: [
                    NotificationRolesEnum.Broker,
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.Buyer,
                    NotificationRolesEnum.BuyerInternalTeamMember,
                    NotificationRolesEnum.BuyerExternalTeamMember,
                ],
                order: {
                    [NotificationRolesEnum.Broker]: 13,
                    [NotificationRolesEnum.CurrentPracticeOwner]: 13,
                    [NotificationRolesEnum.Buyer]: 11,
                },
            },
            {
                type: DigestNotificationTypeEnum.NewSellerStepBegins,
                roles: [
                    NotificationRolesEnum.Broker,
                    NotificationRolesEnum.CurrentPracticeOwner,
                    NotificationRolesEnum.Buyer,
                    NotificationRolesEnum.BuyerInternalTeamMember,
                ],
                order: {
                    [NotificationRolesEnum.Broker]: 3,
                    [NotificationRolesEnum.CurrentPracticeOwner]: 3,
                },
            },
            {
                type: DigestNotificationTypeEnum.NewMessageInBuyerChat,
                roles: [
                    NotificationRolesEnum.Broker,
                    NotificationRolesEnum.CurrentPracticeOwner,
                ],
                order: {
                    [NotificationRolesEnum.Broker]: 9,
                    [NotificationRolesEnum.CurrentPracticeOwner]: 9,
                },
            },
            {
                type: DigestNotificationTypeEnum.NewMessageInBrokerChat,
                roles: [
                    NotificationRolesEnum.Broker,
                    NotificationRolesEnum.CurrentPracticeOwner,
                ],
                order: {
                    [NotificationRolesEnum.Broker]: 4,
                    [NotificationRolesEnum.CurrentPracticeOwner]: 4,
                },
            },
            {
                type: DigestNotificationTypeEnum.UpdateToBuyersTable,
                roles: [
                    NotificationRolesEnum.Broker,
                    NotificationRolesEnum.CurrentPracticeOwner,
                ],
                order: {
                    [NotificationRolesEnum.Broker]: 7,
                    [NotificationRolesEnum.CurrentPracticeOwner]: 7,
                },
            },
            {
                type: DigestNotificationTypeEnum.PracticeDataAndDocsNewProject,
                roles: [
                    NotificationRolesEnum.Broker,
                    NotificationRolesEnum.CurrentPracticeOwner,
                ],
                order: {
                    [NotificationRolesEnum.Broker]: 5,
                    [NotificationRolesEnum.CurrentPracticeOwner]: 5,
                },
            },
            {
                type: DigestNotificationTypeEnum.NewMessageInBrokerChat,
                roles: [NotificationRolesEnum.Broker],
            },
            {
                type: DigestNotificationTypeEnum.NewMessageInSellerChat,
                roles: [
                    NotificationRolesEnum.Broker,
                    NotificationRolesEnum.Buyer,
                    NotificationRolesEnum.BuyerInternalTeamMember,
                    NotificationRolesEnum.BuyerExternalTeamMember,
                ],
                order: {
                    [NotificationRolesEnum.Buyer]: 7,
                },
            },
            {
                type: DigestNotificationTypeEnum.NewOpportunitiesPosted,
                roles: [
                    NotificationRolesEnum.Broker,
                    NotificationRolesEnum.Buyer,
                ],
                order: {
                    [NotificationRolesEnum.Buyer]: 3,
                },
            },
            {
                type: DigestNotificationTypeEnum.NewBuyerStepBegins,
                roles: [
                    NotificationRolesEnum.Buyer,
                    NotificationRolesEnum.BuyerInternalTeamMember,
                ],
                order: {
                    [NotificationRolesEnum.Buyer]: 4,
                },
            },
            {
                type: DigestNotificationTypeEnum.MonthlyEngagementFeeInvoicePosted,
                roles: [NotificationRolesEnum.CurrentPracticeOwner],
                order: {
                    [NotificationRolesEnum.CurrentPracticeOwner]: 14,
                },
            },
            {
                type: DigestNotificationTypeEnum.TransactionDocumentsDraftsPosted,
                roles: [NotificationRolesEnum.CurrentPracticeOwner],
                order: {
                    [NotificationRolesEnum.CurrentPracticeOwner]: 15,
                },
            },
        ],
    },
];

export type NotificationDescriptor = {
    type: DigestNotificationTypeEnum;
    roles: NotificationRolesEnum[];
    order?: Partial<Record<NotificationRolesEnum, number>>;
};

export interface NotificationCategoryDescriptor {
    category: DigestNotificationCategory;
    label: string;
    venueIds: VenueId[];
    notifications: NotificationDescriptor[];
}
